import React, { useState } from "react";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import InputGroup from "./../../elements/InputGroup";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const COAModal = ({ SaveCOA, setCreateCOAModal,saveLable="Proceed" }) => {
  const [coaName, setCoaName] = useState("");

  return (
    <Modal
      title="Chart of Accounts"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setCreateCOAModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setCreateCOAModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label={saveLable}
            onClick={() => {
              SaveCOA(coaName);
              setCoaName("");
            }}
          />
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <InputGroup
          label="Name of the COA"
          inputs={[
            <>
              <input
                type="text"
                value={coaName}
                onChange={(event) => setCoaName(event.target.value)}
                placeholder="Enter COA Name"
              />
            </>,
          ]}
        />
      </div>
    </Modal>
  );
};

export default COAModal;
